import React from 'react';
import { useIntl } from 'react-intl';

import Panel from '@ts-core/components/Panel/Panel';
import Typography from '@ts-core/components/Typography';

import { Exercise } from '../../types';

import SelectedExercisesList from './SelectedExercisesList';

interface SelectedExercisesPanelProps {
  exercises: Exercise[];

  onRemoveExercise: (exercise: Exercise) => void;
  onRemoveAllExercises: () => void;
  onSortExercises: (from: number, to: number) => void;
}

const SelectedExercisesPanel = (props: SelectedExercisesPanelProps) => {
  const intl = useIntl();
  const { exercises, onRemoveExercise, onRemoveAllExercises, onSortExercises } = props;

  return (
    <Panel>
      <Typography variant="subtitle2">{intl.formatMessage({ id: 'practiceSession.selectedExercises' })}</Typography>
      <SelectedExercisesList
        exercises={exercises}
        onRemoveExercise={onRemoveExercise}
        onRemoveAllExercises={onRemoveAllExercises}
        onSortExercises={onSortExercises}
      />
    </Panel>
  );
};

export default SelectedExercisesPanel;
